import moment from 'moment'

const prepareShow = meeting => {
  meeting.meeting_date = moment(meeting.meeting_date, 'YYYYMMDD').format('DD/MM/YYYY')
  return meeting
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  setDoSearch (dt) {
    this.search.generic = dt
    this.setPage(1)
  },
  getYears () {
    this.$http.get('/v1/dweller/meeting/years')
    .then(({data}) => {
      this.years = data
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/index/resources/methods.js